import { render } from "./About.vue?vue&type=template&id=74d10bc7"
const script = {}
script.render = render

export default script